import React from "react";
import { Select } from "antd";

export default function CashierTag({
    value,
    onChange,
    style = { width: "50%" },
    disabled = false,
    usageScope,
    tags
    /* {"pos_tag_id":number,"usage_scope":string,"pos_tag_name":string} */
}) {
    return (
        <Select
            mode="multiple"
            style={{ ...style }}
            placeholder="Select tags"
            value={value || []}
            onChange={onChange}
            optionFilterProp="children"
            disabled={disabled}
        >
            {tags
                .filter(
                    tag =>
                        tag.usage_scope === usageScope ||
                        tag.usage_scope === "ALL"
                )
                .map(tag => (
                    <Select.Option key={tag.pos_tag_id} value={tag.pos_tag_id}>
                        {tag.pos_tag_name}
                    </Select.Option>
                ))}
        </Select>
    );
}

